export default __webpack_public_path__ + "db58878.png";